import fetch from '../../utils/fetch'

export function sendMes(phonenumber) {
    return fetch({
        url: '/api/verify/sendMes?phonenumber=' + phonenumber,
        method: 'GET',
    })
}

export function register(params) {
    return fetch({
        url: '/api/verify/wxRegister',
        method: 'POST',
        data: params
    })
}
export function xcxRegister(params) {
    return fetch({
        url: '/api/verify/xcxRegister',
        method: 'POST',
        data: params
    })
}

